import { PkIcon } from '@uefadigital/panenka-react';
import type { ICellRendererParams } from 'ag-grid-community';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { useWindowSize } from '@hooks/useWindowSize';
import type { Coefficient } from '@shared-types/coefficient.types';
import { CoefficientTrend } from '@shared-types/coefficient.types';

const trendMapping = {
  [CoefficientTrend.STABLE]: {
    icon: 'actions-equal',
    color: 'ui-04',
  },
  [CoefficientTrend.UP]: {
    icon: 'football-substitution-in',
    color: 'support-01',
  },
  [CoefficientTrend.DOWN]: {
    icon: 'football-substitution-out',
    color: 'support-04',
  },
} as const;

const Position = ({ value, data, showTrend }: ICellRendererParams<Coefficient, string> & { showTrend: boolean }) => {
  const { isMobile } = useWindowSize();

  const trend = useMemo(
    () => showTrend && trendMapping[data.overallRanking?.trend],
    [data.overallRanking?.trend, showTrend],
  );

  return (
    <div className={clsx('pk-d--flex pk-align-items--center', showTrend && 'pk-justify-content--between pk-gap--xs2')}>
      <span className='pk-font--base-regular pk-font-size--xs2 pk-font-size-sm--s pk-text--text-02'>{value}</span>
      {trend && (
        <PkIcon name={trend.icon} color={trend.color} size={isMobile ? 14 : 18} title={data.overallRanking?.trend} />
      )}
    </div>
  );
};

export default memo(Position);
